import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, zip } from 'rxjs';
import { map } from 'rxjs/operators';

import { DadosConciliacao } from '../models/dados-conciliacao';
import { ConciliacaoApiService } from '../services/conciliacao-api.service';


@Injectable()
export class EditarConciliacaoResolver implements Resolve<DadosConciliacao> {

  constructor(
    private conciliacaoApiService: ConciliacaoApiService,
  ) { }

  resolve(router: ActivatedRouteSnapshot): Observable<DadosConciliacao> {
    const conciliacaoId: number = router.params['conciliacaoId'];
    const conciliacao: Observable<DadosConciliacao> = this.conciliacaoApiService.getDadosConciliacaoExistente(conciliacaoId);

    return zip(conciliacao).pipe(
      map((values) => {
        return values[0];
      })
    );
  }
}